angular.module('angus.services').service('nextGenNavigationService', [
    '$location', '$window', 'sideMenuService',
    function($location, $window, sideMenuService) {

        const appBaseUrl = window.env.envApp;

        function buildNextGenUrl(path) {
            const url = new URL(path, appBaseUrl);
            const impersonatedUserValue = $window.sessionStorage.getItem('angus_impersonationUser');
            const impersonatedUser = impersonatedUserValue ? JSON.parse(impersonatedUserValue) : null;

            if (impersonatedUser && impersonatedUser.userId) {
                url.searchParams.set('impersonateUserId', impersonatedUser.userId);
            }

            return url.toString();
        }

        this.goToSignIn = () => {
            let url = `${appBaseUrl}/auth/sign-in`;
            const encodeUrl = encodeURIComponent($location.absUrl());

            if (encodeUrl) {
                url += `?returnUrl=${encodeUrl}`;
            }

            $window.location.href = url;
        };

        this.openNextGenInNewContext = () => {
            $window.open(buildNextGenUrl('/home'), '_blank', 'noopener');
            sideMenuService.close();
        };
    }
]);
